/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useNavEnrollCtaSlot } from 'bundles/unified-common/providers/NavEnrollCtaProvider';

const styles = {
  slot: css`
    display: flex;
    align-items: center;

    /* Before a page module portals its CTA in, this div has no children -- collapse it out of the
       nav's flex layout entirely so it doesn't count as a sibling for the row's own gap/margins
       (MERCH-3449: a zero-width flex item still opens a gutter next to its neighbor). Once a CTA is
       portaled in, this no longer matches and the slot re-joins the row normally. */
    &:empty {
      display: none;
    }
  `,
};

/**
 * Empty portal target for the XDP Enroll CTA. Renders nothing until a page module portals into it.
 */
const MobileWebEnrollGridItem = () => {
  const { setSlot } = useNavEnrollCtaSlot();

  return <div ref={setSlot} css={styles.slot} data-testid="mobile-web-enroll-slot" />;
};

export default MobileWebEnrollGridItem;
